import { extractOnlyNumbers, parseOnlyNumericValue, removeAllSpaces, removeMultipleSpace, removeSpecialCharAndNumFn, removeSpecialCharAndNumFn1, removeUnderScrSpCharSpaceBet, sliceText } from "../../../utils/common";
import { safeString } from "../../../utils/logger";

export const BENEFICIARY_INITIAL_STATE = {
  name: null,
  relationship: null,
  date_of_birth: "",
  contact_no: "",
  address: "",
  percentage_of_benefit: "",
  // idProof:"",
  bank_name: "",
  account_number: "",
  ifcs: "",
};
export const BENEFICIARY_FORM_FIELDS = {
  name: {
    name: "name",
    inputType: "inputField",
    component: "InputField",
    type: "text",
    label: "Nominee Name",
    fullWidth: true,
    placeholder: "Type Here...",
    required: true,
    customOptions: {
      formatValueFn: (value) => {
        value = sliceText(removeSpecialCharAndNumFn1(safeString(value), 150))
        return value;
      },
    },
  },
  relationship: {
    name: "relationship",
    inputType: "selectField",
    component: "SelectField",
    label: "Nominee Relation",
    fullWidth: true,
    options: [
      { id: "Father", name: "Father" },
      { id: "Mother", name: "Mother" },
      { id: "Son", name: "Son" },
      { id: "Daughter", name: "Daughter" },
      { id: "Spouse", name: "Spouse" },
      // { id: "Child", name: "Child" },
      // { id: "Parent", name: "Parent" },
      // { id: "Sibling", name: "Sibling" },
      // { id: "Grandparent", name: "Grandparent" },
      // { id: "Grandchild", name: "Grandchild" },
      // { id: "Guardian", name: "Guardian" },
      // { id: "Relative", name: "Relative" },
      // { id: "Friend", name: "Friend" },
    ],
    placeholder: "Select Here...",
    required: true,
  },
  date_of_birth: {
    name: "date_of_birth",
    inputType: "inputField",
    component: "InputField",
    type: "date",
    label: "DOB",
    fullWidth: true,
    placeholder: "Select Here...",
    required: true,
  },
  contact_no: {
    name: "contact_no",
    inputType: "inputField",
    component: "InputField",

    label: "Contact Number",
    fullWidth: true,
    placeholder: "Type Here...",
    required: true,
    customOptions: {
      formatValueFn: (value) => {
        value = sliceText(parseOnlyNumericValue(removeAllSpaces(value)), 10);
        return value;
      }
    }
  },
  address: {
    name: "address",
    inputType: "inputField",
    component: "InputField",
    type: "text",
    label: "Address",
    fullWidth: true,
    placeholder: "Type Here...",
    required: false,
    customOptions: {
      formatValueFn: (value) => {
        value = sliceText(removeMultipleSpace(safeString(value)), 150);
        return value;
      }
    }
  },
  percentage_of_benefit: {
    name: "percentage_of_benefit",
    inputType: "inputField",
    component: "InputField",
    type: "number",
    label: "Percentage of Benefits",
    fullWidth: true,
    placeholder: "Type Here...",
    prefix: "%",
    required: true,
  },
  // idProof: {
  //   name: "idProof",
  //   inputType: "inputField",
  //   component: "InputField",
  //   type: "file",
  //   label: "ID Proof",
  //   fullWidth: true,
  //   placeholder: "Type Here...",
  //   required: true,
  // },


  bank_name: {
    name: "bank_name",
    inputType: "inputField",
    component: "InputField",
    type: "text",
    label: "Bank Name",
    fullWidth: true,
    placeholder: "Type Here...",
    required: false,
    customOptions: {
      formatValueFn: (value) => {
        value = sliceText(removeSpecialCharAndNumFn(safeString(value), 150));
        return value;
      },
    },
  },
  account_number: {
    name: "account_number",
    inputType: "inputField",
    component: "InputField",

    label: "Account Number",
    fullWidth: true,
    placeholder: "Type Here...",
    required: false,
    customOptions: {
      formatValueFn: (value) => {
        return sliceText(extractOnlyNumbers(value), 11);
      },
    },
  },
  ifcs: {
    name: "ifcs",
    inputType: "inputField",
    component: "InputField",
    type: "text",
    label: "IFSC Code",
    fullWidth: true,
    placeholder: "Type Here...",
    required: false,
    customOptions: {
      formatValueFn: (value) => {
        return sliceText(removeUnderScrSpCharSpaceBet(value).toUpperCase(), 11);
      },
    },
  },
};

export const BENEFICIARY_API = {
  BENEFICIARY_CREATE: { url: "/employee/nominee", method: "POST" },
  BENEFICIARY_UPDATE: { url: "/employee/nominee", method: "PUT" },
  BENEFICIARY_DELETE: { url: "/employee/nominee", method: "DELETE" },
  BENEFICIARY_LIST: { url: "/employee/nominee", method: "GET" },
  MASTER_BENEFICIARY_LIST: {
    url: "/organization/org-bank/admin/master",
    method: "GET",
  },
};

